import type { ProgramEventListType } from 'models';
import { useCallback } from 'react';
import { BellRingingLineIcon, CalendarLineIcon, type TagProperties, TelehealthLineIcon } from 'ui';

export const useGetEventTypeTagProperties = () =>
  useCallback(
    ({ eventType }: { eventType: ProgramEventListType }): Pick<TagProperties, 'children' | 'color' | 'icon'> => {
      switch (eventType) {
        case 'call':
        case 'clinical_review':
          // Call event and clinical review event are not supported yet
          return {
            children: undefined,
            color: undefined,
            icon: undefined,
          };
        case 'conference':
        case 'video_conference':
          return {
            children: 'Video Conference',
            color: 'pink',
            icon: <CalendarLineIcon />,
          };
        case 'reminder':
          return {
            children: 'Reminder',
            color: 'cyan',
            icon: <BellRingingLineIcon />,
          };
        case 'telehealth_visit':
          return {
            children: 'Telehealth Visit',
            color: 'blue',
            icon: <TelehealthLineIcon />,
          };
        case 'webinar':
          return {
            children: 'Webinar',
            color: 'pink',
            icon: <CalendarLineIcon />,
          };
      }
    },
    [],
  );
